"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromScopedBearRef = exports.fromBearRef = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * Converts reference into a format acceptable by the SPI. URI references are left as-is, while
 * the identifier references have the object type added.
 *
 * @param ref - reference
 * @param defaultType - type to use it the ref has none specified
 * @internal
 */
function fromBearRef(ref, defaultType) {
    var _a;
    if (sdk_model_1.isUriRef(ref)) {
        return ref;
    }
    return { identifier: ref.identifier, type: (_a = ref.type) !== null && _a !== void 0 ? _a : defaultType };
}
exports.fromBearRef = fromBearRef;
/**
 * Converts scoped reference into a format acceptable by the bear SPI. URI references are left as-is, scoped
 * references are left as is, while the identifier references have the object type added.
 *
 * @param ref - reference
 * @param defaultType - type to use it the ref has none specified
 * @internal
 */
function fromScopedBearRef(ref, defaultType) {
    if (sdk_model_1.isLocalIdRef(ref)) {
        return ref;
    }
    return fromBearRef(ref, defaultType);
}
exports.fromScopedBearRef = fromScopedBearRef;
//# sourceMappingURL=ObjRefConverter.js.map